import React from 'react';
import { useParams } from 'react-router-dom';
import BackButton from '../components/microComponents/BackButton';

const LiveClassDetails = () => {
    const { url } = useParams();
    return (
        <div className='Container'>
            <BackButton title={"Class Video"} isSticky={true} />
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // height: "100vh",
                boxSizing: "border-box",
                borderRadius: "8px",
                overflow: "hidden",
                marginBottom: "20px",
            }}>
                <div style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "960px", // Optional: limits max size
                    paddingTop: "56.25%", // 16:9 aspect ratio (9 / 16 = 0.5625)
                }}>
                    <iframe
                        src={`https://www.youtube.com/embed/${url}`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default LiveClassDetails;